import { client } from "../../../infrastructure/graphql/client";
import {
  GET_DISK_ANALYSIS,
  ANALYZE_ALL_VMS_DISKS,
} from "../../../infrastructure/graphql/aiQueries/diskAnalysisQueries";

export class DiskAnalysisService {
  async getDiskAnalysis(vmId) {
    try {
      const result = await client.query({
        query: GET_DISK_ANALYSIS,
        variables: { vmId },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getDiskAnalysis;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get disk analysis error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeAllVmsDisks() {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_ALL_VMS_DISKS,
      });

      const response = result.data?.analyzeAllVmsDisks;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze all VMs disks error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}